import React, { useEffect, useMemo, useState } from 'react';
import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { stringNormalize } from '../../../../util/stringNormalize';

import {
  fetchAudiosRequest,
  uploadAudiosRequest,
  deleteAudioRequest,
} from '../../../../store/actions/voice-bots-tts';

import * as S from './styles';

const SubMenuAudioUpload = ({ isActive, botId }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const { voiceBotAudios } = useSelector((state) => state.voiceBotTts);
  const [currentAudio, setCurrentAudio] = useState(null);
  const [currentAudioId, setCurrentAudioId] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    if (botId) {
      dispatch(fetchAudiosRequest({ botId }));
    }
  }, [botId]);

  const filteredAudios = useMemo(() => {
    if (!searchTerm) return voiceBotAudios;

    const findAudios = voiceBotAudios.filter((audio) => {
      const audioNameNormalized = stringNormalize(audio.name);
      const searchTermNormalized = stringNormalize(searchTerm);

      return audioNameNormalized.includes(searchTermNormalized);
    });

    return findAudios;
  }, [voiceBotAudios, searchTerm]);

  const handlePauseAudio = () => {
    if (currentAudio) {
      currentAudio.pause();
      currentAudio.currentTime = 0;
      setCurrentAudioId(null);
    }
  };

  const handlePlayAudio = (url, id) => {
    handlePauseAudio();

    const audio = new Audio(url);
    setCurrentAudio(audio);
    audio.play();
    setCurrentAudioId(id);
    audio.addEventListener('ended', () => setCurrentAudioId(null));
  };

  const hanldeDeleteAudio = (_id) => {
    dispatch(
      deleteAudioRequest({
        _id,
      })
    );
  };

  const hanldeUploadAudio = (event) => {
    const { files } = event.target;

    if (files?.length) {
      dispatch(
        uploadAudiosRequest({
          botId,
          files: [...files],
        })
      );
    }
  };

  return (
    <S.SubMenuAudioUploadWrapper className={classnames({ open: isActive })}>
      <div className="header">
        <h3>Banco de áudios</h3>
        <label htmlFor="audio_upload" className="btn btn-primary">
          Upload de áudio
        </label>
        <input
          id="audio_upload"
          type="file"
          accept=".wav, .mp3"
          onChange={hanldeUploadAudio}
          multiple
        />
      </div>

      <div className="container-input-search">
        <input
          className="input-search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Pesquisar"
        />
      </div>

      <S.TableAudioUploadedWrapper>
        <table>
          <thead>
            <tr>
              <th>Áudio</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {filteredAudios?.map((audio) => (
              <tr key={audio._id}>
                <td>{audio.name}</td>
                <td>
                  {currentAudioId === audio._id ? (
                    <button type="button" onClick={() => handlePauseAudio()}>
                      parar
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={() => handlePlayAudio(audio.url, audio._id)}
                    >
                      tocar
                    </button>
                  )}
                  <button
                    type="button"
                    onClick={() => hanldeDeleteAudio(audio._id)}
                  >
                    excluir
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </S.TableAudioUploadedWrapper>
    </S.SubMenuAudioUploadWrapper>
  );
};

export default SubMenuAudioUpload;
